__webpack_require__.p = "https://fe-static-dev.hkgai.net/meeting-ai-fe-web/18369/";